import { render, staticRenderFns } from "./unit-card.vue?vue&type=template&id=9dcbd6e2&"
import script from "./unit-card.ts?vue&type=script&lang=ts&"
export * from "./unit-card.ts?vue&type=script&lang=ts&"
import style0 from "./unit-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports